import UserPanelContainer, {MODE} from "../UserPanelContainer"
import messageResource from "../../../messageResource"
import {connect} from "../../../redux/utils"
import {bindActionCreators} from "redux"
import {
    isLastLicenseManagerOnDeleteAlertShown,
    isLastLicenseManagerOnDisableApAlertShown,
    isLastLicenseManagerOnDisableAtAlertShown,
    isUpdatingWorkSchedule,
    selectEditUserPanel
} from "./selectors"
import Header from "./Header"
import {resetTimeZoneGroupRow, resetUserGroupRow, setTimeZoneGroupData, setUserGroupData, validateTimeZoneGroup,} from "../userData/actions"
import {
    addNewSchedule,
    changeTeamAssignments,
    deleteUser,
    deleteUserSchedule,
    restoreState,
    setHasLeavesOrTTBeforeNewHireDateError,
    setLastLicenseManagerOnDeleteAlertShown,
    setLastLicenseManagerOnDisableApAlertShown,
    setLastLicenseManagerOnDisableAtAlertShown,
    setUserPanelTab,
    updateAccess,
    updateAccessAP,
    updateEmail,
    updateFirstName,
    updateHireDate,
    updateInitialUserSchedule,
    updateLastName,
    updateMiddleName,
    updateOvertime,
    updatePassword,
    updateReleaseDate,
    updateRequireApproval,
    updateTimeZoneGroup,
    updateUserGroup,
    updateUserName,
    updateUserRights,
    updateUserSchedules,
} from "./actions"
import {getAllApprovers, getManagementAssignmentsCounters, getUserDataWithAdditionalData} from '../userData/selectors'
import {openTeamAssignmentsPanelFromEditPanel} from "../editTeamAssignmentsPanel/actions"
import {setEventPreventHidingTeamAssignmentSlidingPanel} from "../../utils"
import UserGroupRow from '../components/UserGroupRow'
import TimeZoneGroupRow from '../components/TimeZoneGroupRow'
import {openManagementAssignmentPanel} from '../../../administration/userManagement/editManagementAssignmentsPanel/actions'
import {GROUP_NEW_OR_NOT_KNOWN} from '../constants'
import {getLoggedInUserId} from "../../../loggedInUser/selectors"
import {isUpdating} from '../accountSettings/userRates/selectors'
import {getAuthorizationInfo} from '../authorizationInfo/selectors'
import {getTimeZoneGroupsList, getUserGroupsList} from '../../../administration/darSettings/selectors'
import {setUserManagementData} from '../../../administration/userManagement/common/actions'
import {getUserManagementData} from '../../../administration/userManagement/common/selectors'
import ConfirmationDialog from '../../../components/ConfirmationDialog/ConfirmationDialog'
import $ from '../../../alias/jquery'
import LastManagerInfo from './LastManagerInfo'
import {Product, PRODUCTS_INTEGRATED} from '../../../constants'

class EditUserPanelContainer extends UserPanelContainer {

    constructor({
        actions
    }) {
        super({
            accountSettingsId: "editUserPanel",
            mode: MODE.EDIT,
            actions
        })

        this.state = {
            ...super.state,
            isLastLicenseManagerOnDeleteAlertShown: false,
            isLastLicenseManagerOnDisableAtAlertShown: false,
            isLastLicenseManagerOnDisableApAlertShown: false,
        }

        this.onStatePropertyChanged('selectedTab', selectedTab => {
            this.userPanelContent.setState({
                currentTabKey: selectedTab,
            })
        })

        this.onStatePropertyBecameTrue('isLastLicenseManagerOnDeleteAlertShown', () => this.deleteAlert.show())
        this.onStatePropertyBecameTrue('isLastLicenseManagerOnDisableAtAlertShown', () => this.disableAtAlert.show())
        this.onStatePropertyBecameTrue('isLastLicenseManagerOnDisableApAlertShown', () => this.disableApAlert.show())

        this.onStatePropertyChanged('allApprovers', approversList => {this.accountSettingsTab.setState({approversList})})
    }

    afterRender() {
        this.$el.attr("id", "editUserPanel")
        this.$el.addClass("components_editUserPanel")

        this.header = new Header().init(this.find('.panelHeader'))
        this._createLastManagerInfoComponents()
        super.afterRender()
    }

    subscribeForEvents() {
        super.subscribeForEvents()

        this.header.on('deleteUser', () => {
            if (confirm(messageResource.getMessage("userlist.js.confirm_delete_user"))) {
                this.actions.deleteUser(false)
            }
        })

        this.accountSettingsTab.accountInformation.on('changeAccess', () => {
            this.actions.updateAccess(!this.state.fullUserInfo.enabled, false)
        })

        this.accountSettingsTab.accountInformation.on('changeAccessToOtherProduct', () => {
            this.actions.updateAccessAP(!this.state.fullUserInfo.enabledInOtherProduct, false)
        })
    }

    _createLastManagerInfoComponents() {
        this.deleteLastManagerInfo = new LastManagerInfo({isDeleting: true})
        const $body = $('body')
        this.deleteAlert = new ConfirmationDialog({
            onShow: () => this.deleteLastManagerInfo.setState({
                userName: `${this.state.fullUserInfo.firstName} ${this.state.fullUserInfo.lastName}`
            }),
            // pass first force = true due to last approver check done before last LM
            onConfirm: () => this.actions.deleteUser(true, true),
            onHide: () => this.actions.setLastLicenseManagerOnDeleteAlertShown(false),
            contentComponent: this.deleteLastManagerInfo,
        }).init($body)

        this.disableAtLastManagerInfo = new LastManagerInfo({})
        this.disableAtAlert = new ConfirmationDialog({
            onShow: () => this.disableAtLastManagerInfo.setState({
                userName: `${this.state.fullUserInfo.firstName} ${this.state.fullUserInfo.lastName}`,
            }),
            // pass first force = true due to last approver check done before last LM
            onConfirm: () => this.actions.updateAccess(!this.state.fullUserInfo.enabled, true, true),
            onCancel: () => this.accountSettingsTab.accountInformation.editAccountInformation.accessSelector.setState({enabled: this.state.fullUserInfo.enabled}),
            onHide: () => this.actions.setLastLicenseManagerOnDisableAtAlertShown(false),
            contentComponent: this.disableAtLastManagerInfo,
        }).init($body)

        this.disableApLastManagerInfo = new LastManagerInfo({product: Product.actiPLANS})
        this.disableApAlert = new ConfirmationDialog({
            onShow: () => this.disableApLastManagerInfo.setState({
                userName: `${this.state.fullUserInfo.firstName} ${this.state.fullUserInfo.lastName}`,
            }),
            // pass first force = true due to last approver check done before last LM
            onConfirm: () => this.actions.updateAccessAP(!this.state.fullUserInfo.enabledInOtherProduct, true, true),
            onCancel: () => this.accountSettingsTab.accountInformation.editAccountInformation.accessToOtherProductSelector.setState({enabled: this.state.fullUserInfo.enabledInOtherProduct}),
            onHide: () => this.actions.setLastLicenseManagerOnDisableApAlertShown(false),
            contentComponent: this.disableApLastManagerInfo,
        }).init($body)
    }

    _handleTeamAssignmentsPanelVisibility = (visible, e) => {
        this.actions.openTeamAssignmentsPanelFromEditPanel()
        setEventPreventHidingTeamAssignmentSlidingPanel(e)
    }

    _createUserGroupRowComponent() {
        return new UserGroupRow({
            showSaveButton: true,
            createNewUserGroup: (name) => this.actions.updateUserGroup(GROUP_NEW_OR_NOT_KNOWN, name),
            onGroupChanged: (id) => this.actions.updateUserGroup(id, ""),
            updateRowDate: (data) => this.actions.setUserGroupData(data),
            resetGroup: () => this.actions.resetUserGroupRow(),
        })
    }

    _createTimeZoneGroupRowComponent() {
        return new TimeZoneGroupRow({
            showSaveButton: true,
            createNewGroup: (data) => this.actions.updateTimeZoneGroup(GROUP_NEW_OR_NOT_KNOWN, data),
            onGroupChanged: (id) => this.actions.updateTimeZoneGroup(id, null),
            updateRowDate: (data) => this.actions.setTimeZoneGroupData(data),
            resetGroup: () => this.actions.resetTimeZoneGroupRow(),
            validateTimeZoneGroup: (tzgId, newTzg) => this.actions.validateTimeZoneGroup(tzgId, newTzg),
        })
    }
}

export default connect(
    state => ({
        ...selectEditUserPanel(state),
        ...getUserDataWithAdditionalData(state),
        ...getAuthorizationInfo(state),
        userManagementData: getUserManagementData(state),
        loggedInUserId: getLoggedInUserId(state),
        managementAssignmentsCounts: getManagementAssignmentsCounters(state),
        updatingUserRates: isUpdating(state),
        updatingWorkSchedule: isUpdatingWorkSchedule(state),
        allUserGroups: getUserGroupsList(state),
        allTimeZoneGroups: getTimeZoneGroupsList(state),
        allApprovers: getAllApprovers(state),
        isLastLicenseManagerOnDeleteAlertShown: isLastLicenseManagerOnDeleteAlertShown(state),
        isLastLicenseManagerOnDisableAtAlertShown: isLastLicenseManagerOnDisableAtAlertShown(state),
        isLastLicenseManagerOnDisableApAlertShown: isLastLicenseManagerOnDisableApAlertShown(state),
    }),
    dispatch => ({
        actions: {
            restoreState: bindActionCreators(restoreState, dispatch),
            switchTab: bindActionCreators(setUserPanelTab, dispatch),
            ...bindActionCreators({
                updateFirstName,
                updateLastName,
                updateMiddleName,
                updateUserName,
                updateEmail,
                updatePassword,
                updateUserGroup,
                setUserGroupData,
                resetUserGroupRow,
                updateTimeZoneGroup,
                validateTimeZoneGroup,
                setTimeZoneGroupData,
                resetTimeZoneGroupRow,
                updateHireDate,
                setHasLeavesOrTTBeforeNewHireDateError,
                updateReleaseDate,
                updateAccess,
                updateAccessAP,
                updateRequireApproval,
                updateUserSchedules,
                updateInitialUserSchedule,
                addNewSchedule,
                deleteUserSchedule,
                updateOvertime,
                changeTeamAssignments,
                updateUserRights,
                deleteUser,
                openTeamAssignmentsPanelFromEditPanel,
                openManagementAssignmentPanel,
                setUserManagementData,
                setLastLicenseManagerOnDeleteAlertShown,
                setLastLicenseManagerOnDisableAtAlertShown,
                setLastLicenseManagerOnDisableApAlertShown,
            }, dispatch)
        }
    })
)(EditUserPanelContainer)



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/EditUserPanelContainer.js